import { MoreVertical } from 'lucide-react';

import { CenterFlex } from '@/components/base';
import Button from '@/components/Button/Button';
import Menu from '@/components/Menu/Menu';
import service from '@/services/index';
import { useToast } from '@/stores/pure/ToastStore';

type Props = {
  alias: string;
  refetch: () => void;
};

const ChartListItemAction = (props: Props) => {
  const addToast = useToast();

  const onDeleteClick = async () => {
    await service.chart.deleteChart(props.alias);
    addToast('Chart deleted', 'success');
    props.refetch();
  };

  const onDuplicateClick = async () => {
    await service.chart.duplicateChart(props.alias);
    addToast('Chart duplicated', 'success');
    props.refetch();
  };

  return (
    <CenterFlex width="100%">
      <Menu
        triggerNode={
          <Button variant="ghost" sizeType="m" leftIcon={<MoreVertical />} />
        }
        options={[
          {
            label: 'Delete',
            onClick: onDeleteClick,
          },
          {
            label: 'Duplicate',
            onClick: onDuplicateClick,
          },
        ]}
      />
    </CenterFlex>
  );
};

export default ChartListItemAction;
